import type { SVGProps } from 'react'
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="info_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#info_svg__a)">
      <path d="M8.183 12.817h1.634V8.25H8.183zM9 6.84q.357 0 .598-.242.242-.24.242-.598a.81.81 0 0 0-.242-.598A.81.81 0 0 0 9 5.16a.81.81 0 0 0-.598.242A.81.81 0 0 0 8.16 6q0 .357.242.598.24.242.598.242m0 9.813a7.5 7.5 0 0 1-2.988-.603 7.7 7.7 0 0 1-2.428-1.634 7.7 7.7 0 0 1-1.634-2.428A7.5 7.5 0 0 1 1.348 9q0-1.591.602-2.988.602-1.396 1.634-2.428A7.7 7.7 0 0 1 6.012 1.95 7.5 7.5 0 0 1 9 1.348q1.592 0 2.988.602t2.428 1.634a7.7 7.7 0 0 1 1.634 2.428A7.5 7.5 0 0 1 16.652 9a7.5 7.5 0 0 1-.602 2.988 7.7 7.7 0 0 1-1.634 2.428 7.7 7.7 0 0 1-2.428 1.634A7.5 7.5 0 0 1 9 16.652m0-1.707q2.495 0 4.22-1.726 1.726-1.725 1.726-4.22T13.22 4.78Q11.495 3.054 9 3.054T4.78 4.78 3.054 9t1.726 4.22Q6.505 14.946 9 14.946" />
    </g>
  </svg>
)
export default SvgInfo
